import CFetch from "../fetch";
import { APIEndpoints } from "@urbancarecommunity/commons/constants";
import { CarerEndpoints } from "@urbancarecommunity/commons/constants";

const endpoints = new APIEndpoints<typeof CarerEndpoints>(
  CarerEndpoints,
  import.meta.env.VUE_API_CARER_URL as string
).get();

export const addJobRole = (userId: string, details: any) => {
  return CFetch.callAPI(endpoints.role.buildWithParams({ id: userId }), {
    method: "POST",
    body: details,
  });
};

export const getJobRoles = (userId: string) => {
  return CFetch.callAPI(endpoints.role.buildWithParams({ id: userId }));
};

export const getAllJobRoles = (userId: string) => {
  return CFetch.callAPI(endpoints.role.buildWithParams({ id: userId }));
};

export const getAllUnapprovedJobRoles = (page = 1, limit = 10) => {
  return CFetch.callAPI(endpoints.allRoles.build(), {
    params: { page: String(page), limit: String(limit) },
  });
};
export const getAllApprovedJobRoles = (page = 1, limit = 10) => {
  return CFetch.callAPI(endpoints.activeRoles.build(), {
    params: { page: String(page), limit: String(limit) },
  });
};
export const getAllRejectedRoles = (page = 1, limit = 10) => {
  return CFetch.callAPI(endpoints.rejectRoles.build(), {
    params: { page: String(page), limit: String(limit) },
  });
};
export const getAllExpiredRoles = (page = 1, limit = 10) => {
  return CFetch.callAPI(endpoints.expiredRoles.build(), {
    params: { page: String(page), limit: String(limit) },
  });
};

// Fetches rejected + expired + withdrawn roles in a single API call.
export const getAllHistoryRoles = (page = 1, limit = 10) => {
  return CFetch.callAPI(endpoints.historyRoles.build(), {
    params: { page: String(page), limit: String(limit) },
  });
};
export const approveJobRole = (userId: string, roleId: string) => {
  return CFetch.callAPI(
    endpoints.approveRole.buildWithParams({ id: userId, roleId }),
    { method: "PUT" }
  );
};

export const rejectJobRole = (userId: string, roleId: string) => {
  return CFetch.callAPI(
    endpoints.rejectRole.buildWithParams({ id: userId, roleId }),
    { method: "PUT" }
  );
};

export const withdrawJobRole = (userId: string, roleId: string) => {
  return CFetch.callAPI(
    endpoints.withdrawRole.buildWithParams({ id: userId, roleId }),
    { method: "PUT" }
  );
};
